import clsx from 'clsx';

interface SkeletonProps {
    className?: string;
    count?: number;
}

export default function Skeleton({ className, count = 1 }: SkeletonProps) {
    return (
        <>
            {[...Array(count)].map((_, i) => (
                <span
                    key={`${i}`}
                    className={clsx(
                        'inline-block animate-pulse bg-cloud-300',
                        className
                    )}
                />
            ))}
        </>
    );
}

export function SkeletonSubCategoryCard({ className, count }: SkeletonProps) {
    return (
        <Skeleton
            className={clsx('h-40 w-[552px] rounded-3xl', className)}
            count={count}
        />
    );
}
